import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ConnectionHandlerPropsType } from 'components/helper/Connection/Handler';
import ConnectionHandler from 'components/helper/Connection/Handler';
import {
	getAnyOutgoingFetchRequestFailed,
	getAnyOutgoingSaveRequestFailed,
	getAssumeUserIsOffline,
	getHasChunkErrors,
	getHasRequestErrors,
	getIsOnline,
} from 'store/connection';
import { getIsDataBagAvailable } from 'store/offlineAvailability';
import { getCurrentViewID } from 'store/view';
import { WithRouterType } from 'types/withRouter';

const mapStateToProps = (state: any, ownProps: WithRouterType): ConnectionHandlerPropsType | any => {
	const currentViewID: string = getCurrentViewID(state) || '';
	const isOnline: boolean = getIsOnline(state);
	const isDataBagAvailable: boolean = getIsDataBagAvailable(state, currentViewID, ownProps.match.params);
	const hasRequestErrors: boolean = getHasRequestErrors(state);
	const hasChunkErrors: boolean = getHasChunkErrors(state);
	const assumeUserIsOffline: boolean = getAssumeUserIsOffline(state);
	const anyOutgoingSaveRequestFailed: boolean = getAnyOutgoingSaveRequestFailed(state);
	const anyOutgoingFetchRequestFailed: boolean = getAnyOutgoingFetchRequestFailed(state);

	return {
		currentViewID,
		isOnline,
		isDataBagAvailable,
		hasRequestErrors,
		hasChunkErrors,
		assumeUserIsOffline,
		anyOutgoingSaveRequestFailed,
		anyOutgoingFetchRequestFailed,
		signature: [
			`${currentViewID || 'initial'}`,
			`${isOnline ? 0 : 1}`,
			`${isDataBagAvailable ? 0 : 1}`,
			`${hasRequestErrors ? 0 : 1}`,
			`${anyOutgoingSaveRequestFailed ? 1 : 0}`,
			`${anyOutgoingFetchRequestFailed ? 1 : 0}`,
			`${hasChunkErrors ? 0 : 1}`,
		].join(''),
	};
};

export default withRouter(connect(mapStateToProps)(ConnectionHandler) as any);
